<div class="Pen" data-behaviour="pen">
  <div class="Pen-panel Pen-header">
    <h1 class="fdx-u-font-size--h4 fdx-u-text--light fdx-u-mb--4 fdx-u-mr--2 fdx-u-mt--6" aria-label="deviceTableTitle">
      {{'deviceManagement.deviceTableTitle' | translate}}
    </h1>
  </div>
  <p aria-atomic="true" aria-live="assertive" class="fdx-u-font-size--default fdx-u-text--light fdx-u-align--left fdx-u-mt--0 fdx-u-mb--6 fdx-u-mr--10">
    <span aria-live="assertive" aria-atomic="true" aria-label="deviceTableSubtitle">
      {{'deviceManagement.deviceTableSubtitle' | translate}}
    </span>
  </p>
  @if (!showMessage) {
    <wpro-device-table (isAPIFailLoginScreen)="isAPIFailLoginScreen($event)"></wpro-device-table>
  }
  @if (showMessage) {
    <wpro-login-call-failure [deviceInfoFlag]="showMessage"></wpro-login-call-failure>
  }
</div>